import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceAgentGuidedVariantSizeRowButtonProps = Omit<
  ComponentPropsWithoutRef<'button'>,
  'className' | 'type'
> & {
  isSelected?: boolean;
};

export const WorkspaceAgentGuidedVariantSizeRowButton = memo(
  ({ isSelected = false, ...props }: WorkspaceAgentGuidedVariantSizeRowButtonProps) => (
    <button
      type="button"
      {...props}
      className={cn(
        'flex min-h-8 w-full items-center gap-1.5 rounded-4 px-1.5 text-left ads:text-primary text-14 text-gray-12 ads:hover:bg-hover-subtle hover:bg-gray-4',
        isSelected && 'ads:bg-subtle bg-gray-3',
      )}
    />
  ),
);

WorkspaceAgentGuidedVariantSizeRowButton.displayName = 'WorkspaceAgentGuidedVariantSizeRowButton';
